export const environment = {
  production: true,
  useJson: true,
  jsonBaseUrl: 'https://addtix.oss-ap-southeast-5.aliyuncs.com/',
  apiBaseUrl: 'https://battle-plane.addtix.id/',
  assetBaseUrl: 'https://addtix.oss-ap-southeast-5.aliyuncs.com/',
  gmapsApiKey: 'AIzaSyCZsWjf59fifB2fb5N7lbx_092cM_DH6ho',
  // xendit_public_key: 'xnd_public_development_dOPYH6NYUwgOJY1sg3JoMTV1Ag7wOb1LX3OyjUrwZxt0HF1Q7juX1py4Tcd1M9id',
  xendit_public_key: 'xnd_public_production_nny_CO95aRC8tVta0RStvOMXY3z5wjetNG0cUONjtKdEO0gw0Pt0uMPKRD1cF4J',
  bankTransferAccountNo:'5435-788-855',
  bankTransferAccountName:'PT Reservasi Multi Teknologi',
  senangPayMerchantId:'328177621890464',
  senangPayUrl:'https://app.senangpay.my/payment',
  senangPayTimeout:600,
  firebase: {
    apiKey: "AIzaSyDcaWNhWuzWKckMPc2Fj8G3zeqr3Ju9wF8",
    authDomain: "cognitix-fd040.firebaseapp.com",
    projectId: "cognitix-fd040",
    storageBucket: "cognitix-fd040.appspot.com",
    messagingSenderId: "71263280967",
    appId: "1:71263280967:web:41fb3040f55b7a3a9db662",
    measurementId: "G-6WPGYHFR7S"
  },
  recaptcha: {
    siteKey: '6Ldg14gqAAAAAOZMrmSBDcPSUCij-nNwxc3B_K_G',
    secretKey: '6Ldg14gqAAAAAI1r8Nk0Hv3ImzK4sRaAt4kpsCtV',
  },
  fingerprint:{
    apiKey: 'OLJjYeruo2RP4iZzP3AY',
    region: "ap"
  },
  sentry: {
    dsn: 'https://6a6a41bde47e86bf0a06feb54ace7681@o4508758216605696.ingest.us.sentry.io/4508759734681600'
  },
  akId: 510,
  redirect: {
    510: 'https://www.aaronkwokinjkt.com/',
    547: 'https://www.overpassinjakarta2025.com/',
    554: 'https://www.richierenindonesia.com/',
    612: 'https://reg.iiccsforum.com/',
    669: 'https://www.bithelastparadeinjakarta.com/',
  },
  clId: 491,
  klbbBRIId: 545,
  kahitnaId: 556,
  esId: 559,
  miId: 560,
  pixelsData: [
    {
      eventId: 559,
      tagId: '602058486125181',
    },
    {
      eventId: 560,
      tagId: '602058486125181',
    },
    {
      eventId: 597,
      tagId: '664352389287247',
    },
    {
      eventId: 599,
      tagId: '664352389287247',
    },
    {
      eventId: 600,
      tagId: '664352389287247',
    },
    {
      eventId: 606,
      tagId: '664352389287247',
    },
    {
      eventId: 594,
      tagId: '1836268923835848',
    },
    {
      eventId: 799,
      tagId: '1734574133894082',
    },
    {
      eventId: 508,
      tagId: '1157413122934268',
    },
    {
      eventId: 844,
      tagId: '1734574133894082',
    },
    {
      eventId: 1005,
      tagId: '794504289764272',
    },
    {
      eventId: 1012,
      tagId: '2242891506447807',
    },
    {
      eventId: 1013,
      tagId: '2242891506447807',
    },
  ],
  gtmData: [
    {
      eventId: 660,
      tagId: 'GTM-NT7DRX29',
    },
    {
      eventId: 785,
      tagId: 'GTM-W5TRWSHQ',
    }
  ],
  amLounge:{
    tagId: '1112597976803774',
    events: [550,549,548,607]
  },
  eventIdBca: 508,
  eventIdOcbc: 552,
  dewa19CFUrl: 'https://redemption-jersey-dewa19.addtix.id/',
  dewa19Slug: 'pengambilan-jersey-dewa-19',
  dewa19id: 659,
  dewa19rdr: 'https://www.dewa19allstars.com/',
  bsrId:660,
  biId:669,
  biIdList: [669,861],
  JDIOId: 989,
  JDIOIDId: 997,
  rawDanceId: 1007,
  whiteLabel: [
    {
      slug: 'indonesia-derby-2025',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'sarga-festival-2025',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'affiliate-festival-sarga',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'ihr-cup-ii',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'sarga',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'm7',
      logo: 'm7-logo.png',
      type: 'advance',
      promoter: 'Moonton',
      phone: '+62821-2599-9908',
      wa: '6282125999908',
      email: 'info@addtix.id',
      address: 'Jakarta',
    },
    {
      slug: 'im3',
      logo: 'IM3-logo.png',
      type: 'advance',
      promoter: 'IM3',
      phone: '+62858‑9451‑1819',
      wa: '6285894511819',
      email: 'info@addtix.id',
      address: 'Jakarta',
    },
  ],
  mustSource: [{
    id: 847,
    source:'mypertamina'
  }],
  seatingMapAtelier: [
    {
      id: 2175,
      key: 'regular-1st-floor',
    },
    {
      id: 2174,
      key: 'vip-1st-floor',
    },
    {
      id: 2256,
      key: 'regular-2nd-floor-left',
    },
    {
      id: 2257,
      key: 'regular-2nd-floor-center',
    },
    {
      id: 2258,
      key: 'regular-2nd-floor-right',
    },
    {
      id: 2255,
      key: 'vip-2nd-floor',
    },
  ]
};
